export const CDN_BASE_URL = "https://dnh2lg9wxf8si.cloudfront.net";

export const cdnUrl = (path = "") => {
    if (!path) return CDN_BASE_URL;
    if (/^https?:\/\//i.test(path)) return path;
    return `${CDN_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
